import { Component, Input, OnInit } from '@angular/core';
import { PaymentService } from '../../services/payment/payment.service';

@Component({
  selector: 'inspector-financial',
  templateUrl: './inspector-financial.component.html',
  styleUrl: './inspector-financial.component.scss'
})
export class InspectorFinancialComponent implements OnInit {

  @Input() orderId;
  transactions: any[] = [];

  constructor(private paymentService: PaymentService) {}

  ngOnInit(): void {
    this.paymentService.getInspectorFinancialTransactions(this.orderId).subscribe(data => {
      this.transactions = data;
    })
  }

}
